/* Presentation only: preserve currency values, forms and native commerce logic. */
(() => {
  if (window.semboniaMoneyFormatReady) return;
  window.semboniaMoneyFormatReady = true;
  const compact = text => text.replace(/\bRM[\s\u00a0\u202f]+(?=\d)/g, 'RM');
  const excluded = 'script,style,noscript,textarea,input,select,[contenteditable="true"]';
  function normalize(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.parentElement || node.parentElement.closest(excluded)) return;
      let value = compact(node.nodeValue);
      if (node.parentElement.closest('.product-label, .card__badge')) {
        value = value.replace(/(\d)[\s\u00a0\u202f]+%/g, '$1%');
      }
      if (value !== node.nodeValue) node.nodeValue = value;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE || node.matches(excluded)) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) normalize(text);
  }
  function start() {
    normalize(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') normalize(record.target);
        else record.addedNodes.forEach(normalize);
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
